/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .idle-icon[_ngcontent-%COMP%]{font-size:3rem;z-index:10;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}[_nghost-%COMP%]   .idle-icon[_ngcontent-%COMP%]     .fa-stack-2x{--fa-secondary-color:#cccccc}[_nghost-%COMP%]   .idle-icon[_ngcontent-%COMP%]     .fa-stack-1x{color:#fe3b1f}[_nghost-%COMP%]   .idle-modal__body[_ngcontent-%COMP%]{padding-top:2rem;text-align:center}[_nghost-%COMP%]   .idle-modal[_ngcontent-%COMP%]     .ui-dialog-titlebar{background-color:#fff}"];
export { styles as styles };
